<template>
	<main class="about">

		<!-- Header -->
		<theme-header />

		<!-- Breadcrumb -->
		<breadcrumb title="About us" subpage="pages" currentpage="about-us" />

		<!-- Our Story -->
		<our-story />

		<!-- Our Team -->
		<our-team />

		<!-- Fun Facts -->
		<fun-facts />

		<!-- Testimonial -->
		<testimonial-section />

		<!-- Related Post -->
		<related-posts />

		<!-- Clients -->
		<client-section />

		<!-- Footer -->
		<theme-footer />

		<back-to-top btnText="Back to top" :showIcon="true" />

	</main>
</template>

<script>
import ThemeFooter from '../components/common/ThemeFooter.vue'
import ThemeHeader from '../components/common/ThemeHeader.vue'
import BackToTop from '../components/pieces/BackToTop.vue'
import Breadcrumb from '../components/pieces/Breadcrumb.vue'
import FunFacts from '../components/sections/FunFacts.vue'
import OurStory from '../components/sections/OurStory.vue'
import OurTeam from '../components/sections/OurTeam.vue'
import TestimonialSection from '../components/sections/TestimonialSection.vue'
import RelatedPosts from '../components/sections/blogs/RelatedPosts.vue'
import ClientSection from '../components/sections/ClientSection.vue'

export default {
	name: 'About',
	components: {
		ThemeHeader,
		ThemeFooter,
		BackToTop,
		Breadcrumb,
		OurStory,
		OurTeam,
		FunFacts,
		TestimonialSection,
		RelatedPosts,
		ClientSection
	}
  
}
</script>
